import { render, staticRenderFns } from "./VideoDemo.vue?vue&type=template&id=df3b55a8&scoped=true"
import script from "./VideoDemo.vue?vue&type=script&lang=js"
export * from "./VideoDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3b55a8",
  null
  
)

export default component.exports